import type { FaireProductEntity } from "../../entity_types/product";

export const p_yjmgktu8c2: FaireProductEntity = {
  token: "p_yjmgktu8c2",
  type: "product",
  name: "SKATE DECK NARUTO COLLECTION",
  brandToken: "b_9grp69f3nm",
  brandName: "Unknown Brand",
  imageUrl: "https://cdn.faire.com/fastly/eb3dd098473a0a838fa16ba0f7bda10ed7ce57b17f40c3700d30ea8b48cfb605.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e5165c7816fe473a20f457e8ce1a8a4cd1b359b66c505d1ca334bca9af865635.jpeg",
    "https://cdn.faire.com/fastly/5a1f57c89f42caa95c3431b24ffa4ae2403fb29e04a40a4731b93c5110fe8263.jpeg",
    "https://cdn.faire.com/fastly/afa9c5348fbb9c04ed7ca8d4e7a85dc6c40c6dd8d87a608663fce28c799c8840.jpeg",
    "https://cdn.faire.com/fastly/f507381026996863d48adde3b88b07674e1b2c544f440dfc3157a29ae7d0c47c.jpeg"
  ],
  priceDollars: 44.69,
  description: "High Quality Skateboard Deck\n\nWelcome to the NARUTO X Hydroponic Official Collaboration, packed with quality skateboard decks, wheels, complete skates, griptape, and an astounding Apparel Collection.\n\nHYDROPONIC Skateboards are high-quality decks made with 7 plies of Canadian Hard Rock Maple wood and glued with ultra-strong Epoxy resin to get a reactive pop that will last for the whole life of the board. HYDROPONIC Skate decks come in a wide variety of sizes, depending on your height, weight, and Skate Style.\n\nDeck: 7-ply Hard Rock Canadian Maple + Epoxy Resin\n\nConcave: High",
  tags: [],
  msrpDollars: 89.38,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:47.779Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
